import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=82ef59aa&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=82ef59aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ef59aa",
  null
  
)

export default component.exports